import { useCallback } from 'react';
import { useWeb3React } from '@web3-react/core';
import useWeb3 from '../useWeb3';
import { rockBalance } from '../../utils/contractHelpers';
import { gemsRouterContract, rockRelayerContract } from '../../utils/Enviroment';

export const useRockAllowance = () => {
    const { account } = useWeb3React();
    const web3 = useWeb3();

    const rockAllowance = useCallback(async (contractAddress, isTokenGraduated = false) => {
        const contract = await rockBalance(contractAddress, web3);
        if (!contract) {
            console.error("Contract not initialized properly.");
            return;
        }
        try {

            const allowance = await contract.methods.allowance(account, isTokenGraduated ? rockRelayerContract : gemsRouterContract).call();
            const formattedAllowance = web3.utils.fromWei(String(allowance), 'ether');
            return formattedAllowance;
        } catch (error) {
            console.error("Check Allowance error:", error);
            throw error;
        }
    }, [account]);

    return { rockAllowance };
};
export default useRockAllowance;